import { api } from '../api';
import type { BrandSpecialQualifyingStatus } from './brandSpecial.types';

export interface BrandSpecialQualifyingStatusProps {
  cartUuid?: string;
  specialId?: string | number;
  storeId?: string | number;
}

const brandSpecialQualifyingStatusUrls = {
  brandSpecialQualifyingStatus: (props: BrandSpecialQualifyingStatusProps) =>
    `/v1/stores/${props.storeId}/brand_specials/${props.specialId}/qualifying_status/${props.cartUuid}`,
};

export const fetchBrandSpecialQualifyingStatus = (
  props: BrandSpecialQualifyingStatusProps
) => {
  const url =
    brandSpecialQualifyingStatusUrls.brandSpecialQualifyingStatus(props);

  return api.get<BrandSpecialQualifyingStatus>(url);
};
